import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DashboardHeader from '../components/DashboardHeader';
import AdminSidebar from '../components/AdminSidebar';
import ScrollToTop from '../components/ScrollToTop';
import styles from './AdminLayout.module.css';

function AdminLayout() {
  const location = useLocation();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileSidebarOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileSidebarOpen]);

  return (
    <div className={styles.layout}>
      <ScrollToTop />
      <DashboardHeader
        mobileSidebarOpen={mobileSidebarOpen}
        onToggleSidebar={() => setMobileSidebarOpen((prev) => !prev)}
      />
      <div className={styles.body}>
        <aside className={`${styles.sidebarDrawer} ${mobileSidebarOpen ? styles.sidebarDrawerOpen : ''}`}>
          <AdminSidebar onNavigate={() => setMobileSidebarOpen(false)} />
        </aside>
        {mobileSidebarOpen && (
          <button
            type="button"
            aria-label="Close navigation menu"
            className={styles.mobileBackdrop}
            onClick={() => setMobileSidebarOpen(false)}
          />
        )}
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
